import { Axis, DisplayMode } from '../typing/enums';

export const getSizeByAxisAndDisplayMode = data =>
  data.axis === Axis.HORIZONTAL
    ? `width: ${data.wrapWidth}px;`
    : data.mode === DisplayMode.CLASSIC
      ? `height: ${data.wrapHeight}px;`
      : 'height: auto;';
